import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { OrderedMap } from "immutable";
import * as React from "react";
const roomFilterStateZero = {};
export const capacityOptions = OrderedMap([
    [
        'a',
        {
            min: 0,
            max: 10,
            label: "Minder dan 10"
        }
    ],
    [
        'b',
        {
            min: 10,
            max: 50,
            label: "Tussen 10 en 50"
        }
    ],
    [
        'c',
        {
            min: 50,
            max: Number.MAX_SAFE_INTEGER,
            label: "Meer dan 50"
        }
    ]
]);
export class RoomFilter extends React.Component {
    render() {
        const eventTypeFilter = /*#__PURE__*/ _jsxs("div", {
            className: "o-filter__field form__select form__item--icon left",
            children: [
                /*#__PURE__*/ _jsxs("select", {
                    onChange: (e)=>this.props.selectEventType(e.target.value),
                    disabled: !this.props.enabled,
                    value: this.props.selectedEventType,
                    id: "zvf-type",
                    children: [
                        /*#__PURE__*/ _jsx("option", {
                            value: "",
                            children: "Kies een opstelling"
                        }, "event-type-all"),
                        this.props.eventTypes.map((title)=>/*#__PURE__*/ _jsx("option", {
                                value: title,
                                children: title
                            }, title))
                    ]
                }),
                /*#__PURE__*/ _jsx("svg", {
                    className: "form__icon",
                    width: "23px",
                    height: "22px",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ _jsx("use", {
                        xlinkHref: "#icon--type"
                    })
                })
            ]
        });
        const capacityFilter = /*#__PURE__*/ _jsxs("div", {
            className: "o-filter__field form__select form__item--icon left",
            children: [
                /*#__PURE__*/ _jsxs("select", {
                    onChange: (e)=>this.props.selectCapacity(e.target.value),
                    value: this.props.selectedCapacity,
                    disabled: !this.props.enabled,
                    id: "zvf-capacity",
                    children: [
                        /*#__PURE__*/ _jsx("option", {
                            value: "",
                            children: "Kies een capaciteit"
                        }, "event-type-all"),
                        capacityOptions.map((option, key)=>/*#__PURE__*/ _jsx("option", {
                                value: key,
                                children: option.label
                            }, key)).toArray()
                    ]
                }),
                /*#__PURE__*/ _jsx("svg", {
                    className: "form__icon",
                    width: "24px",
                    height: "20px",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ _jsx("use", {
                        xlinkHref: "#icon--capacity"
                    })
                })
            ]
        });
        return /*#__PURE__*/ _jsxs("fieldset", {
            className: "o-filter o-filter--two zv-filter",
            children: [
                /*#__PURE__*/ _jsx("legend", {
                    className: "sr-text",
                    children: "Filter zalen op evenement types en capaciteit"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "o-filter__inner zv-filter__inner",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "o-filter__item",
                            children: [
                                /*#__PURE__*/ _jsx("label", {
                                    className: "o-filter__label text--s",
                                    htmlFor: "zvf-type",
                                    children: "Evenement type"
                                }),
                                eventTypeFilter
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "o-filter__item ",
                            children: [
                                /*#__PURE__*/ _jsx("label", {
                                    className: "o-filter__label text--s",
                                    htmlFor: "zvf-capacity",
                                    children: "Capaciteit"
                                }),
                                capacityFilter
                            ]
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = roomFilterStateZero;
    }
}
{}